import { catalogueProductsTableTranslations } from './components/Tables/Brand/CatalogueProductsTable/translations';
import { confirmPopupTranslations } from './components/PopUps/ConfirmDialog/translations';
import { navBarTranslations } from './components/Core/Navbar/translations';
import { pointsTranslations } from 'containers/Points/translations';
import { pointsTableTranslations } from 'components/Tables/Point/PointsTable/translations';
import { brandsTableTranslations } from 'components/Tables/Brand/BrandsTable/translations';
import { pointTranslations } from 'containers/Point/translations';
import { pointBasicFormTranslations } from 'components/Forms/PointBasicForm/translations';
import { pointScheduleTableTranslations } from 'components/Tables/Point/PointScheduleTable/translations';
import { appLoaderTranslations } from 'components/Core/AppLoader/translations';
import { noDataTranslations } from 'components/Core/NoData/translations';
import { requestsTranslations } from 'containers/Requests/translations';
import { brandsRequestsTableTranslations } from 'components/Tables/BrandsRequestsTable/translations';
import { profileTranslations } from 'containers/Profile/translations';
import { discountsTranslations } from 'containers/Discounts/translations';
import { discountsTableTranslations } from 'components/Tables/DiscountsTable/translations';
import { discountTranslations } from 'containers/Discount/translations';
import { brandsTranslations } from 'containers/Brands/translations';
import { brandTranslations } from 'containers/Brand/translations';
import { requestPopUpTransFieldsTranslations } from 'components/PopUps/RequestPopUp/translations';
import { brandBasicFormTranslations } from 'components/Forms/BrandBasicForm/translations';
import { uploadInputTranslations } from 'components/Inputs/UploadInput/translations';
import { mapBoxTranslations } from 'components/Core/MapBox/translations';
import { pointLogsTableTranslations } from 'components/Tables/Point/PointLogsTable/translations';
import { pointsLogsFiltersFormTranslations } from 'components/Forms/PointsLogsFiltersForm/translations';
import { statusCellTranslations } from 'components/Core/StatusCell/translations';
import { polygonsStatusCellTranslations } from 'components/Core/PolygonsStatusCell/translations';
import { reviewsTranslations } from 'containers/Reviews/translations';
import { reviewsTableTranslations } from 'components/Tables/ReviewsTable/translations';
import { brandsCataloguesTableTranslations } from 'components/Tables/Brand/BrandsCataloguesTable/translations';
import { brandsCataloguesFiltersFormTranslations } from 'components/Forms/BrandsCataloguesFiltersForm/translations';
import { brandsCatalogueFormTranslations } from 'components/Forms/BrandCatalogueForm/translations';
import { cataloguesPagesTableTranslations } from 'components/Tables/Brand/CataloguesPagesTable/translations';
import { brandCataloguesTranslations } from 'components/BrandComponents/BrandCataloguesPage/translations';
import { tableActionsButtonsTranslations } from 'components/RequestsComponents/TableActionsButtons/translations';
import { requestsTableFiltersTranslations } from 'components/RequestsComponents/RequestsTableFiltersForm/translations';
import { brandRequestFormTranslations } from 'components/Forms/BrandRequestForm/translations';
import { pointRequestFormTranslations } from 'components/Forms/PointRequestForm/translations';
import { productRequestFormTranslations } from 'components/Forms/ProductRequestForm/translations';
import { pointsRequestsTableTranslations } from 'components/Tables/ProductsRequestsTable/translations';
import { adminUsersTranslations } from 'containers/AdminUsers/translations';
import { adminUsersPopupTranslations } from 'components/PopUps/AdminUserPopUp/translations';
import { createdBySelectTranslations } from 'components/Inputs/CreatedBySelect/translations';
import { productsTranslations } from 'containers/Products/translations';
import { productsTableTranslations } from 'components/Tables/ProductsTable/translations';
import { productFormTranslations } from 'components/Forms/ProductBasicForm/translations';
import { productTranslations } from 'containers/Product/translations';
import { cataloguesRequestsTableTranslations } from 'components/Tables/CataloguesRequestsTable/translations';
import { catalogueRequestFormTranslations } from 'components/Forms/CatalogueRequestForm/translations';
import { parsersTranslations } from 'containers/Parsers/translations';
import { adminUsersTableTranslations } from 'components/Tables/AdminUsersTable/translations';
import { parsersTableTranslations } from 'components/Tables/ParsersTable/translations';
import { editParserTranslations } from 'containers/EditParser/translations';
import { parserFormTranslations } from 'components/Forms/ParsersForm/translations';
import { isDeletedSelectTranslations } from 'components/Inputs/IsDeletedSelect/translations';
import { entityTitleTranslations } from 'components/Core/EntityTitle/translations';
import { confirmWithCodePopUpTranslations } from 'components/PopUps/ConfirmWithCodePopUp/translations';
import { countryFormTranslations } from 'components/Forms/CountryForm/translations';
import { countriesTranslations } from 'containers/Countries/translations';
import { countriesTableTranslations } from 'components/Tables/CountriesTable/translations';
import { popularProductsTableTranslations } from 'components/Tables/PopularProductsTable/translations';
import { popularProductsTranslations } from 'containers/PopularProducts/translations';
import { popularProductFormTranslations } from 'components/Forms/PopularProductForm/translations';
import { categoriesTranslations } from 'containers/Categories/translations';
import { pointsCategoriesTableTranslations } from 'components/Tables/PointsCategoriesTable/translations';
import { productCategoriesTableTranslations } from 'components/Tables/ProductCategoriesTable/translations';
import { productCategoryKeywordsFormTranslations } from 'components/Forms/ProductCategoryKeywordsForm/translations';
import { productCategoryBasicFormTranslations } from 'components/Forms/ProductCategoryBasicForm/translations';
import { categoryTranslations } from 'containers/Category/translations';
import { pointCategoryBasicFormTranslations } from 'components/Forms/PointCategoryBasicForm/translations';
import { scriptsTableTranslations } from 'components/Tables/ScriptsTable/translations';
import { scriptBasicFormTranslations } from 'components/Forms/ScriptBasicForm/translations';
import { scriptTranslations } from 'containers/Script/translations';
import { TranslationsForMobileFormTranslations } from 'components/Forms/TranslationsForMobileForm/translations';
import { scriptsTranslations } from 'containers/Scripts/translations';
import { searchCoverageTranslations } from 'containers/SearchCoverage/translations';
import { noCountriesTranslations } from 'components/Core/NoCountries/translations';

export const translations = [
  noCountriesTranslations,
  navBarTranslations,
  appLoaderTranslations,
  noDataTranslations,
  pointsTranslations,
  pointsTableTranslations,
  pointTranslations,
  pointBasicFormTranslations,
  pointScheduleTableTranslations,
  requestsTranslations,
  brandsRequestsTableTranslations,
  profileTranslations,
  confirmPopupTranslations,
  discountsTranslations,
  discountsTableTranslations,
  discountTranslations,
  brandsTableTranslations,
  brandsTranslations,
  brandTranslations,
  requestPopUpTransFieldsTranslations,
  brandBasicFormTranslations,
  uploadInputTranslations,
  mapBoxTranslations,
  pointLogsTableTranslations,
  pointsLogsFiltersFormTranslations,
  statusCellTranslations,
  polygonsStatusCellTranslations,
  reviewsTranslations,
  reviewsTableTranslations,
  brandsCataloguesTableTranslations,
  brandsCataloguesFiltersFormTranslations,
  brandsCatalogueFormTranslations,
  cataloguesPagesTableTranslations,
  brandCataloguesTranslations,
  catalogueProductsTableTranslations,
  tableActionsButtonsTranslations,
  requestsTableFiltersTranslations,
  pointsRequestsTableTranslations,
  brandRequestFormTranslations,
  pointRequestFormTranslations,
  productRequestFormTranslations,
  adminUsersTranslations,
  adminUsersPopupTranslations,
  adminUsersTableTranslations,
  productFormTranslations,
  createdBySelectTranslations,
  productsTranslations,
  productsTableTranslations,
  productTranslations,
  cataloguesRequestsTableTranslations,
  catalogueRequestFormTranslations,
  parsersTranslations,
  parsersTableTranslations,
  editParserTranslations,
  parserFormTranslations,
  isDeletedSelectTranslations,
  entityTitleTranslations,
  countriesTranslations,
  confirmWithCodePopUpTranslations,
  countryFormTranslations,
  countriesTableTranslations,
  popularProductsTranslations,
  popularProductsTableTranslations,
  popularProductFormTranslations,
  categoriesTranslations,
  pointsCategoriesTableTranslations,
  productCategoriesTableTranslations,
  productCategoryKeywordsFormTranslations,
  productCategoryBasicFormTranslations,
  categoryTranslations,
  pointCategoryBasicFormTranslations,
  scriptsTableTranslations,
  scriptBasicFormTranslations,
  scriptTranslations,
  TranslationsForMobileFormTranslations,
  scriptsTranslations,
  searchCoverageTranslations,
];
